const gpt5BaseModels = [
  {key: "gpt-6.1-sol", name: "GPT 6.1 Sol"},
  {key: "gpt-6-sol", name: "GPT 6 Sol"},
  {key: "gpt-6-luna", name: "GPT 6 Luna"},
  {key: "gpt-5.6-sol", name: "GPT 5.6 Sol"},
  {key: "gpt-5.6-terra", name: "GPT 5.6 Terra"},
  {key: "gpt-5.6-luna", name: "GPT 5.6 Luna"},
  {key: "gpt-5.5", name: "GPT 5.5"},
  {key: "gpt-5.4", name: "GPT 5.4"},
  {key: "gpt-5.4-mini", name: "GPT 5.4 mini"},
  {key: "gpt-5.4-nano", name: "GPT 5.4 nano"},
  {key: "gpt-5.2", name: "GPT 5.2"},
  {key: "gpt-5.1", name: "GPT 5.1"},
  {key: "gpt-5", name: "GPT 5"},
  {key: "gpt-5-mini", name: "GPT 5 mini"},
  {key: "gpt-5-nano", name: "GPT 5 nano"},
];

const extendedEfforts = ["none", "low", "medium", "high", "xhigh"];
const maxEfforts = [...extendedEfforts, "max"];

const reasoningEfforts: Record<string, string[]> = {
  "gpt-6.1-sol": maxEfforts,
  "gpt-6-sol": maxEfforts,
  "gpt-6-luna": maxEfforts,
  "gpt-5.6-sol": maxEfforts,
  "gpt-5.6-terra": maxEfforts,
  "gpt-5.6-luna": maxEfforts,
  "gpt-5.5": extendedEfforts,
  "gpt-5.4": extendedEfforts,
  "gpt-5.4-mini": extendedEfforts,
  "gpt-5.4-nano": extendedEfforts,
  "gpt-5.2": extendedEfforts,
  "gpt-5.1": ["none", "low", "medium", "high"],
  default: ["minimal", "low", "medium", "high"],
};

const gpt5Variants = gpt5BaseModels.flatMap(model =>
  (reasoningEfforts[model.key] ?? reasoningEfforts.default).map(effort => ({
    key: `${model.key}-${effort}`,
    base_model: model.key,
    name: `${model.name} (${effort})`,
    reasoning_effort: effort,
  })),
);

export const llmModels = [
  {key: "gpt-3.5-turbo", name: "GPT 3.5 Turbo", deprecated: true},
  {key: "gpt-4-turbo", name: "GPT 4 Turbo", deprecated: true},
  {key: "gpt-4o", name: "GPT 4o", deprecated: true},
  {key: "gpt-4o-mini", name: "GPT 4o mini", deprecated: true},
  {key: "gpt-4.1", name: "GPT 4.1"},
  {key: "gpt-4.1-mini", name: "GPT 4.1 mini"},
  {key: "gpt-4.1-nano", name: "GPT 4.1 nano"},
  {key: "azure-gpt-4o-mini", name: "Azure - GPT 4o mini"},
  {key: "claude-sonnet-4", name: "Claude Sonnet 4"},
  {key: "claude-sonnet-4.5", name: "Claude Sonnet 4.5"},
  {key: "claude-sonnet-4.6", name: "Claude Sonnet 4.6"},
  {key: "claude-sonnet-5", name: "Claude Sonnet 5"},
  {key: "claude-opus-4", name: "Claude Opus 4"},
  {key: "claude-haiku-3.5", name: "Claude Haiku 3.5"},
  {key: "claude-haiku-4.5", name: "Claude Haiku 4.5"},
  {key: "bedrock-claude-sonnet-4", name: "Bedrock Claude Sonnet 4"},
  {key: "bedrock-claude-sonnet-4.5", name: "Bedrock Claude Sonnet 4.5"},
  {key: "bedrock-claude-sonnet-4.6", name: "Bedrock Claude Sonnet 4.6"},
  {key: "bedrock-claude-sonnet-5", name: "Bedrock Claude Sonnet 5"},
  ...gpt5Variants,
];

export const reasonedLlmModels = [
  {key: "gpt-o1", name: "GPT o1", deprecated: true},
  {key: "gpt-o3", name: "GPT o3", deprecated: true},
  {key: "gpt-o3-mini", name: "GPT o3 mini", deprecated: true},
  {key: "gpt-o4-mini", name: "GPT o4 mini", deprecated: true},
  ...gpt5BaseModels,
];
